import React from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from 'html-react-parser';

import { requestDesignUpdate } from "../../store/requests/thunks/requestDesignUpdate";

import { formatPrice } from "../../helpers/formatPrice";

import OptionList from "../../components/OptionList/OptionList";

const FrameOptions = () => {
  const dispatch = useDispatch();

  const init = useSelector((state) => state.init);
  const Uterum = useSelector((state) => state.Uterum);
  const Result = useSelector((state) => state.Result);

  const { alias, currency } = init;

  /*
  Note:
  FrameArticleErpId -- corresponds to FramePrimed: "NO"
  FramePrimedArticleErpId -- FramePrimed: "YES"
  FramePrimedAddonArticleErpId -- FramePrimed: "YES" (Fira Vinkel)
  FramePaintedArticleErpId -- FramePrimed: "YES" and FrameColor: "WHITE"
  */
  const {
    FrameArticleErpId,
    FramePrimedArticleErpId,
    FramePrimedAddonArticleErpId,
    FramePaintedArticleErpId,
    FramePaintedAddonArticleErpId,
    FramePrimed,
    FrameColor,
  } = Uterum;

  const { FrameArticles } = Result;

  if (!FrameArticles || !FrameArticles.length) {
    console.error("FrameArticles missing in FrameOptions");
    return null;
  }

  // No selection availabie in UI
  const isAlwaysPrimed = !FrameArticleErpId && !FramePaintedArticleErpId;
  // Do not display "NO" option in UI
  const isPrimedOrPainted = !FrameArticleErpId && FramePrimedArticleErpId && FramePaintedArticleErpId;
  // Fira Vinkel
  const isFiraVinkel = (FramePrimedAddonArticleErpId) ? true : false;

  // TODO testa!
  if (isAlwaysPrimed) {
    return (
      <OptionList
        renderAs="disabled"
        label={alias.bfcTreatment}
        disabledMessage={alias.bfcGroundFrameIncluded}
      />
    );
  }

  let defaultPrice = null;
  let frameOptions = [];

  if (FrameArticleErpId) {
    defaultPrice = FrameArticles.find(
      (art) => art.Sku === FrameArticleErpId
    ).Price;

    const cost = formatPrice(0, currency);

    frameOptions.push({
      value: "NO",
      label: `${alias.bfcUntreated}`,
      cost,
    });
  } else if (isPrimedOrPainted) {
    defaultPrice = FrameArticles.find(
      (art) => art.Sku === FramePrimedArticleErpId
    ).Price;
  }

  if (FramePrimedArticleErpId) {
    const primedPrice = isFiraVinkel ?
      FrameArticles.filter(art =>
        art.Sku === FramePrimedArticleErpId ||
        art.Sku === FramePrimedAddonArticleErpId
      ).reduce((a, b) => a.Price + b.Price)
      : FrameArticles.find(art => art.Sku === FramePrimedArticleErpId).Price;

    const cost = formatPrice(primedPrice - defaultPrice, currency);

    frameOptions.push({
      value: "YES",
      label: `${alias.bfcTreated}`,
      cost,
    });
  }

  if (FramePaintedArticleErpId) {
    const paintedPrice = isFiraVinkel ?
      FrameArticles.filter(art =>
        art.Sku === FramePaintedArticleErpId ||
        art.Sku === FramePaintedAddonArticleErpId
      ).reduce((a, b) => a.Price + b.Price)
      : FrameArticles.find(art => art.Sku === FramePaintedArticleErpId).Price;

    const cost = formatPrice(paintedPrice - defaultPrice, currency);

    frameOptions.push({
      value: "WHITE",
      label: `${alias.bfcPaintedWhite}`,
      cost,
    });
  }

  let activeOption = "NO";

  if (FrameColor === "WHITE") {
    activeOption = "WHITE";
  } else if (FramePrimed === "YES") {
    activeOption = "YES";
  }

  return (
    <OptionList
      renderAs="select"
      name="Frame"
      label={alias.bfcTreatment}
      tooltipContent={alias.tooltip_treatment && parse(alias.tooltip_treatment)}
      options={frameOptions}
      activeOptionValueFromParent={activeOption}
      onChange={(value) => {
        if (value !== "NO" && value !== "YES" && value !== "WHITE") {
          console.error(
            "Unexpected input value onChange for OptionList in FrameOptions"
          );
        }

        if (value === "NO" || value === "YES") {
          dispatch(
            requestDesignUpdate({
              uterumProperties: {
                FramePrimed: value,
                FrameColor: null,
                PaintArticleErpId: "", // always reset here
              },
            })
          );
        }

        if (value === "WHITE") {
          dispatch(
            requestDesignUpdate({
              uterumProperties: {
                FramePrimed: "YES",
                FrameColor: value,
                PaintArticleErpId: "", // always reset here
              },
            })
          );
        }
      }}
    />
  );
};

export default FrameOptions;
